import deepmerge from 'deepmerge';

import GO from '../../bluestone/GO';
import deprecatedColors from '../../cobalt/colors/deprecated';
import derivedColors from '../../cobalt/colors/derived/GO';
import type { Colors } from '../../types';
import baseColors from './base/GO';

const colors: Colors = {
  ...GO.colors,
  ...deepmerge(
    deprecatedColors(baseColors, baseColors.primary['50']),
    baseColors
  ),
  ...derivedColors(baseColors),
};

export default colors;
